import { useRef, useState } from "react";
import "../ReportTable.css";
import { useEffect } from "react";
import { Table } from "react-bootstrap";
import CustomerFooter from "./CustomerFooter";
import HeaderCustomer from "./HeaderCustomer";
import './Customer.css';
import { addDays } from 'date-fns';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import ApiHandler from "../../ApiHandler";
import TransferData from "../../TransferData";
import { Button, DatePicker } from "antd";
import dayjs from "dayjs";
import LoaderTri from "../Loader/LoaderTri";
import FirmSelect from './FirmSelect';
import { getReportFirmId, getReportFirmLocalUrl, getReportFirmName } from '../../ClientSelection';
import { toast } from "react-toastify";
import { dateField } from "../../dateOnly";
import ReportExport from "../ReportExport";
import { getLoginId } from "../../loginUser";


const initialValues = {
    from: dayjs(),
    to: dayjs()
};
export default function BillTracking() {
    const [dates, setDates] = useState(initialValues);

    const [showBillTracking, setShowBillTracking] = useState([]);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [alldatesData, setAlldatesData] = useState([])
    const [openDate, setOpenDate] = useState(false)
    const [viewdata, setViewdata] = useState(false)
    // The firm these rows belong to. Held explicitly: reading it from storage
    // at fetch time made the request depend on write ordering.
    const [firm, setFirm] = useState(null)
    const [isLoading, setIsLoading] = useState(false);
    const [range, setRange] = useState([{
        startdate: new Date(),
        endDate: addDays(new Date(), ''),
        key: 'selection'
    }])

    const [changeDatanameTable, setChangeDatanameTable] = useState([]);

    const refOne = useRef(null);

    useEffect(() => {
        document.addEventListener("keydown", hideOnEscape, true)
        document.addEventListener("click", hideOnClickOutside, true)
        return () => {
            document.removeEventListener("keydown", hideOnEscape, true)
            document.removeEventListener("click", hideOnClickOutside, true)
        }
    }, []);

    const hideOnEscape = (e) => {
        // console.log(e.key)
        if (e.key === "Escape") {
            setOpenDate(false)
        }
    }


    const hideOnClickOutside = (e) => {
        if (refOne.current && !refOne.current.contains(e.target)) {
            setOpenDate(false)
        }
    }

    // const handleSelects = (date) => {

    //     let filtered = alldatesData.filter((product) => {

    //         let productDate = new Date(product["date"]);
    //         return (
    //             productDate >= date.selection.startDate &&
    //             productDate <= date.selection.endDate
    //         );
    //     });
    //     setStartDate(date.selection.startDate);
    //     setEndDate(date.selection.endDate);
    //     setShowBillTracking(filtered);
    //     console.log(date.selection.startDate)
    //     console.log(date.selection.endDate)
    // };

    const selectionRange = {
        startDate: startDate,
        endDate: endDate,
        key: "selection",
    };
    // `override` is the firm object when called from the dropdown. Wired to
    // onClick too, so a click event may arrive instead - only accept an object
    // that actually looks like a firm.
    function toGetData(override) {
        const picked =
            (override && typeof override === "object" && override.wClientId)
                ? override
                : firm
        const localUrl = (picked && picked.localUrl) || getReportFirmLocalUrl()
        const clientId = (picked && picked.wClientId) || getReportFirmId()
        if (!localUrl) {
            toast.error("No server configured for the selected firm")
            return
        }
        if (!clientId) {
            toast.error("No firm selected")
            return
        }
        setIsLoading(true)
        setShowBillTracking([])
        setViewdata(true)
        ApiHandler.post({
            url: localUrl + "api/OwnApp/GetCustomerBillTracking",
            data: {
                // startdate: moment(selectionRange.startDate).format("YYYYMMDD"),
                // enddate: moment(selectionRange.endDate).format("YYYYMMDD"),
                // `code` is the customer's login id. It used to repeat the
                // firm's client id, so every firm returned the same rows.
                code: getLoginId(),
                // the firm from the dropdown, in its own field
                wClientId: clientId,
                startdate: dayjs(dates.from).format("YYYYMMDD"),
                enddate: dayjs(dates.to).format("YYYYMMDD"),
            },
            useUserUrl: true
        })
            .then(((result) => {
                console.log(result);
                console.log(result.data);
                setShowBillTracking(result.data)
                setAlldatesData(result.data)

            }))
            .catch(err => {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 401) {
                    console.log(err.response);
                    //   RefreshTokenHandler();
                    //  ToastError("Token has expired Please refresh");
                }
            }).finally(() => {
                setIsLoading(false)
            })






    }

    useEffect(() => {
        setChangeDatanameTable(TransferData);
        console.log(changeDatanameTable)
    }, [changeDatanameTable])


    //const dateField = (Input !== "");

    // Record the firm and reload for it. `firm` state has not updated yet on
    // this tick, so the value is passed straight into toGetData.
    const handleFirmChange = (picked) => {
        setFirm(picked || null);
        setShowBillTracking([]);
        setAlldatesData([]);
        if (viewdata && picked) {
            toGetData(picked);
        }
    };


    const reportRange = dayjs(dates.from).format("DD-MM-YYYY") + " to " +
        dayjs(dates.to).format("DD-MM-YYYY");

    const exportColumns = [
        { key: "date", label: TransferData.orderDate, format: (v, row) => dateField(row, "date", "orderDate", "billDate") },
        { key: "billNo", label: TransferData.billNo },
        { key: "amount", label: TransferData.amount, align: "right" },
        { key: "status", label: TransferData.status },
    ];

    return (<div className="custShell">
        <HeaderCustomer />
        <div className="custMain">
            <div className="row m-0">
                <div className="col-lg-10 offset-lg-1">
                    <h5 style={{
                        marginTop: "20px",
                        // marginLeft: "20px",
                        fontFamily: "sans-serif",
                        // fontSize: "17px",
                        // padding: "10px"

                    }}>Select details to  Track Your Bill</h5>

                    <div className="row">
                        <div className="col-lg-3  ">
                            <FirmSelect
                                    onReady={(picked) => setFirm(picked || null)}
                                    onChange={handleFirmChange}
                                />
                        </div>
                        <div className="col-lg-3  ">
                            <DatePicker.RangePicker
                                format={"DD-MM-YYYY"}
                                size="middle"
                                className=" mb-2 mr-2"
                                value={[dates.from, dates.to]}
                                onChange={(e) => {
                                    console.log(e);

                                    if (e) {
                                        setDates({
                                            from: e[0],
                                            to: e[1],
                                        });
                                    } else {
                                        setDates({ from: null, to: null });
                                    }
                                }}
                            />
                        </div>
                        <div className="col-lg-2  ">
                            <Button
                                type="button"
                                className="btn  mb-2 btn-primary btn-sm"
                                onClick={toGetData}
                            >View</Button>

                        </div>

                        {/* the downloads sit on this line, right-aligned */}
                        <div className="col-lg-4">
                            <ReportExport
                                className="rptExportEnd"
                                title="Bill Tracking"
                                subtitle={[getReportFirmName(), reportRange]}
                                columns={exportColumns}
                                rows={Array.isArray(showBillTracking) ? showBillTracking : []}
                                fileName="bill-tracking"
                            />
                        </div>
                    </div>
                    {/* <div className="enterDateInput">
                        <form >
                            <input
                                value={`${moment(selectionRange.startDate).format("DD-MM-YYYY")} to ${moment(selectionRange.endDate).format("DD-MM-YYYY")}`}
                                //value={`${format(range[0].startdate, 'MM-dd-yyyy')}  to  ${format(range[0].endDate, 'MM-dd-yyyy')} `}
                                readOnly
                                onClick={() => setOpenDate(true)}
                                style={{
                                    width: "300px",
                                    paddingLeft: '30px'

                                }}
                                required

                            />

                            <button

                                type="button"
                                onClick={toGetData}

                            >View</button>

                        </form>
                    </div>
                    <div className="dateRangePicker" ref={refOne}>



                        {

                            openDate &&
                            <DateRange
                                onChange={handleSelects}
                                editableDateInputs={true}
                                moveRangeOnFirstSelection={false}
                                ranges={[selectionRange]}
                                months={2}
                                direction="horizontal"
                                showMonthAndYearPickers={false}
                                className="DaterangePicker"

                            />


                        }
                    </div> */}


                    {
                        viewdata &&
                        <div className="   ">

                            <div className="billTarckData">
                                <h6>Bill Track</h6>

                                <div className="rptScroll">
                                    {


                                        Array.isArray(showBillTracking) && showBillTracking.length > 0 &&
                                        <Table striped className="rptTable">
                                            <thead className="threAd">
                                                <tr className="threAd_tr">



                                                    <th>{TransferData.orderDate}</th>
                                                    <th>{TransferData.billNo}</th>
                                                    <th style={{ textAlign: "right" }}>{TransferData.amount}</th>
                                                    <th>{TransferData.status}</th>

                                                </tr>
                                            </thead>

                                            {


                                                showBillTracking.map((elm, index) => {
                                                    return <tbody className="tboDY" key={index} >
                                                        <tr >

                                                            <td >{dateField(elm, 'date', 'orderDate', 'billDate')}</td>
                                                            <td>{elm.billNo}</td>
                                                            <td style={{ textAlign: "right" }}>{elm.amount}</td>
                                                            <td>{elm.status}</td>

                                                        </tr>
                                                    </tbody>

                                                })

                                            }

                                        </Table >
                                    }
                                </div>

                                {isLoading &&
                                    <div className="d-flex justify-content-center" >
                                        <LoaderTri />

                                    </div>

                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>

        <CustomerFooter />
    </div>)
}